import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-78424a3a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wechat-input"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "custom-title"
}, "已使用GPT模型：", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "custom-title"
}, "选择GPT模型：", -1));
const _hoisted_4 = {
  class: "speech-cell",
  style: {
    "background-color": "#fff"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_form = _resolveComponent("van-form");
  const _component_speechCompVue = _resolveComponent("speechCompVue");
  const _component_van_overlay = _resolveComponent("van-overlay");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_withDirectives(_createVNode(_component_van_cell, {
    class: "gpt-model-cell"
  }, {
    title: _withCtx(() => [_hoisted_2, _createVNode(_component_van_tag, {
      type: "success"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($options.getModelName()), 1)]),
      _: 1
    })]),
    _: 1
  }, 512), [[_vShow, $props.showChoosed]]), _withDirectives(_createVNode(_component_van_cell, {
    class: "gpt-model-cell"
  }, {
    title: _withCtx(() => [_hoisted_3, _createVNode(_component_van_button, {
      onClick: _cache[0] || (_cache[0] = $event => $data.gptModelsVisible = true),
      class: "gpt-model-select",
      "icon-position": "right",
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($options.getModelName()) + " ", 1), _createVNode(_component_van_icon, {
        name: "arrow-down"
      })]),
      _: 1
    })]),
    _: 1
  }, 512), [[_vShow, !$props.showChoosed]]), _createVNode(_component_van_form, {
    onSubmit: $options.onSubmit
  }, {
    default: _withCtx(() => [_withDirectives(_createVNode(_component_van_field, {
      rows: "1",
      autosize: "",
      type: "textarea",
      modelValue: $data.message,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.message = $event),
      placeholder: "输入消息",
      size: "large"
    }, {
      label: _withCtx(() => [_createVNode(_component_van_button, {
        round: "",
        onClick: _cache[1] || (_cache[1] = $event => $data.recording = true)
      }, {
        icon: _withCtx(() => [_createVNode(_component_van_icon, {
          class: "iconfont joinmc-yuyin"
        })]),
        _: 1
      })]),
      button: _withCtx(() => [_createVNode(_component_van_button, {
        "native-type": "submit",
        type: "primary",
        style: {
          "padding": "0 16px",
          "margin-right": "5px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("发送")]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"]), [[_vShow, !$data.recording]])]),
    _: 1
  }, 8, ["onSubmit"]), _withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(_component_speechCompVue, {
    onGetSpeechText: $options.getSpeechText,
    onToggleOverlay: $options.toggleOverlay,
    ref: "speech"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_button, {
      round: "",
      onClick: _cache[3] || (_cache[3] = $event => $data.recording = false),
      style: {
        "padding": "0 5px",
        "border": "none !important",
        "font-size": "22px"
      }
    }, {
      icon: _withCtx(() => [_createVNode(_component_van_icon, {
        class: "iconfont joinmc-jianpanshuru"
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["onGetSpeechText", "onToggleOverlay"])], 512), [[_vShow, $data.recording]])]), _createVNode(_component_van_overlay, {
    show: $data.showOverlay,
    onClick: _cache[4] || (_cache[4] = $event => _ctx.$refs.speech.closeOverlay())
  }, null, 8, ["show"]), _createVNode(_component_van_action_sheet, {
    show: $data.gptModelsVisible,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $data.gptModelsVisible = $event),
    actions: $props.gptActions,
    "cancel-text": "取消",
    title: "切换GPT模型",
    "close-on-click-action": "",
    onSelect: $options.onModelSelect
  }, null, 8, ["show", "actions", "onSelect"])], 64);
}